import { useRef, useState } from "react";
import { toast } from "sonner";
import { Upload, Loader2 } from "lucide-react";
import { uploadImage, formatApiErrorDetail } from "../../lib/api";

export default function ImageUploadButton({ onUploaded, testid = "image-upload-button" }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setUploading(true);
    try {
      const result = await uploadImage(file);
      onUploaded(result.url);
      toast.success("写真をアップロードしました");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setUploading(false);
    }
  };

  return (
    <>
      <input ref={inputRef} type="file" accept="image/jpeg,image/png,image/webp,image/gif" className="hidden" onChange={handleFile} data-testid={`${testid}-input`} />
      <button
        type="button"
        data-testid={testid}
        onClick={() => inputRef.current?.click()}
        disabled={uploading}
        className="flex shrink-0 items-center gap-2 border border-accent px-4 py-2.5 text-xs font-bold text-accent transition-colors hover:bg-accent hover:text-ink disabled:opacity-40"
      >
        {uploading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />}
        {uploading ? "送信中..." : "写真を選ぶ"}
      </button>
    </>
  );
}
